import { DivisionDTO, DossierDTO, Link } from '../api/plyca-dtos';
import { UserDTO } from '../api/plyca-dtos';
import { PaginationInfo } from '../api/PaginationModel';
import { DashBoard } from './Dashboard-dto';

// OBJETO QUE SE ALMACENARA COMO PREFERENCIAS DEL USUARIO EN EL LOCALSTORAGE
export class UserPrefs {
  dossiersViewPrefs: DossiersViewPrefs = new DossiersViewPrefs();
  dossiersViewPrefsV2: DossiersViewPrefsV2 = new DossiersViewPrefsV2();
  tasksViewPrefs: TasksViewPrefs = new TasksViewPrefs();
  documentsViewPrefs: DocumentsViewPrefs = new DocumentsViewPrefs();
  communicationsViewPrefs: CommunicationsViewPrefs = new CommunicationsViewPrefs();
  mainViewPrefs: MainViewPrefs = new MainViewPrefs();
  signaturePrefs: SignaturePrefs = new SignaturePrefs();
  searchDocumentsPrefs: SearchDocumentsViewPrefs = new SearchDocumentsViewPrefs();
  contractsViewPrefs = new ContractViewPrefs();
  locale: string;
}

export class MainViewPrefs {
  selectedDashboardId: string;
  dashboards: Array<DashBoard>;
  welcomeNotesViewed: Array<string>;
  showHelpTags = false;
  ENSAlertViewed = false;
}

export class SignaturePrefs {
  keystore: '';
}

export class DossiersViewPrefs {
  textFilter = '';
  filters: any = {};
  filtrosRapidosActivos = false;

  // VARIABLES PARA PAGINACION
  pagInfo: PaginationInfo;
  pagLinks: Link[];
  currentPage = 0;
  pageSize = 300;
  currentSize: number = this.pageSize;

  // VARIABLES PARA CONTROLAR LA ORDENACION
  sentido = -1;
  orderBy = 'expedienteId';

  activeColumns: any[] = [];
  orderColumns: any[];
  noOrderColumns: any;
}

export class DossiersViewPrefsV2 {
  static getViewPrefs(tipo: string) {
    let viewPrefs = this[tipo];
    if (!viewPrefs) {
      this[tipo] = new DossiersViewPrefs();
    }
    return this[tipo];
  }
  static setViewPrefs(tipo: string, viewPrefs: DossiersViewPrefs) {
    this[tipo] = viewPrefs;
  }
}

export class CommunicationsViewPrefs {

  prefs = new Map<string, DossierCommunicationsPrefs>();
  constructor() {

  }
}
export class DossierCommunicationsPrefs {

  _filters: DossierCommunicationsFiltersDTO;
  activeChannelTab: string;
  pageInfo: PaginationInfo;


  constructor() {
    this.pageInfo = new PaginationInfo();
    this.pageInfo.size = 20;
    this.pageInfo.number = 0;

  }

}
export class DocumentsViewPrefs {
  visibleColumns: any[];
  prefs = new Map<string, DossierDocumentsPrefs>();
  constructor() {

  }
}
export class DossierDocumentsPrefs {
  // VARIABLES PARA ALMACENAR LOS GRUPOS DE CLASIFICACION
  activeGroups: Array<number>;
  activeColumns: Array<number>;
  _filters: DossierDocumentsFiltersDTO;
  _expandedNodes = [];


  constructor() {
    this.activeGroups = [4, 0];
    this.activeColumns = [0, 3, 2];
    this._expandedNodes = [];
  }

}
export class SearchDocumentsViewPrefs {
  pageInfo: PaginationInfo;
  _filters: any;

  constructor() {
    this.pageInfo = new PaginationInfo();
    this.pageInfo.size = 25;
    this.pageInfo.number = 0;

    // this._filters = new DocumentSearchFiltersDTO();
    this._filters = {};
  }
}

export class ContractViewPrefs {
  lastContractSeen: string;
  lastContractSelectedTab: number;
}

export class DossierDocumentsFiltersDTO {
  division?: DivisionDTO;
  dossierId?: string;
  /*
    divisionType: string;
    documentClasses: string[];
    documentFolder: string;

    dossierName: string;

    contractType: MasterDataDTO;
    procedureType: MasterDataDTO;
    organizationalUnitId: OrganizationalUnitDTO;

    stateFrom: Date;
    stateTo: Date;
    stateId: string;
    userStateId: UserDTO;

    signatureFrom: Date;
    signatureTo: Date;
    userSignatureId: UserDTO;

    winnerPartyId: string;
    winnerParty: string;
  */
  includeCancelled: boolean;
  ignoreNotifications: boolean;
  avoidTemporaryDocs: boolean;

  constructor() {

    this.includeCancelled = false;
    this.ignoreNotifications = true;
    this.avoidTemporaryDocs = false;


  }
}

export class DossierCommunicationsFiltersDTO {
  division?: DivisionDTO;
  projectId?: string;
  channelId?: string;
  activityIds?: any[];
  agent?: string;




  constructor() {


  }
}

export class TasksViewPrefs {
  // VARIABLES PARA ALMACENAR LOS FILTROS RAPIDOS
  filters: any = {
    filterText: '',
    filterTipoTarea: '',
    filterTipoExpediente: '',
    filterTipoContrato: '',
    filterDate: '',
    filterBuzon: '',
    groupBy: undefined
  };

  // VARIABLES PARA PAGINACION
  pagInfo: PaginationInfo;
  pagLinks: Link[];
  currentPage = 0;
  pageSize = 300;
  currentSize: number = this.pageSize;

  showProfile = false;

  // VARIABLES PARA CONTROLAR LA ORDENACION
  sentido = true;
  orderBy = '';
}

// OBJETO QUE SE ALMACENARA COMO PREFERENCIAS DEL USUARIO EN EL LOCALSTORAGE
export class SessionInfo {
  // private ACCESSTOKEN = 'id_token';
  // private REFRESHTOKEN = 'refresh_token';
  user: UserDTO;
  accessToken: string;
  refreshToken: string;

  // 0 -> Acceso estandar
  // 1 -> Acceso en modo secretario
  modoAcceso: boolean;
  version: string;
  dossiersViewData: DossiersViewData = new DossiersViewData();
  tasksViewData: TasksViewData = new TasksViewData();
  // extraParams: Son propiedades de cliente que se mantienen al actualzar sesion
  extraParams: {
    [param: string]: string;
  } = {};
}

export class DossiersViewData {
  lastUpdate: Date;
  dossiers: DossierDTO[];
}

export class TasksViewData {
  lastUpdate: Date;
  // dossiers: DossierDTO [];
}
